import React, { memo } from 'react';

import PropTypes from 'prop-types';

import RadioGroup from '../../form/RadioGroup';

const FormGeneratorRadioGroup = ({
  onChange,
  options,
  value = '',
  name = '',
  width,
  ...restProps
}) => (
  <RadioGroup groupName={name} options={options} value={value} onChange={onChange} {...restProps} />
);

FormGeneratorRadioGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  width: PropTypes.string,
};

export default memo(FormGeneratorRadioGroup);
